import { render } from "./HeaderIcon1Configer.vue?vue&type=template&id=90c6f3a8&scoped=true"
import script from "./HeaderIcon1Configer.vue?vue&type=script&lang=js"
export * from "./HeaderIcon1Configer.vue?vue&type=script&lang=js"

import "./HeaderIcon1Configer.vue?vue&type=style&index=0&id=90c6f3a8&lang=scss"
import "./HeaderIcon1Configer.vue?vue&type=style&index=1&id=90c6f3a8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90c6f3a8"]])

export default __exports__